import apiClient from './api';
import axios from 'axios';

export const getSignedUrl = async (type, fileName) => {
  const response = await apiClient.get(`/api/s3/signed-url?type=${type}&fileName=${encodeURIComponent(fileName)}`);
  return response.data.signedUrl;
};

export const getMultipleSignedUrls = async (files) => {
  const payload = files.map(file => ({
    fileName: file.fileName,
    fileType: file.fileType
  }));
  
  const response = await apiClient.post('/api/s3/multiple-signed-urls', {
    files: payload
  });
  
  return response.data;
};

export const uploadToS3 = async (signedUrl, file) => {
  const result = await axios.put(signedUrl, file, {
    headers: {
      'Content-Type': file.type
    }
  });
  
  if (result.status !== 200) {
    throw new Error('Error uploading file');
  }
  
  return signedUrl.split("?")[0];
};

export const uploadMultipleToS3 = async (signedUrlsData, files) => {
  const uploadPromises = signedUrlsData.map((data, index) => {
    const blob = files[index].blob;
    return axios.put(data.signedUrl, blob, {
      headers: {
        'Content-Type': blob.type
      }
    }).then(() => {
      return { originalName: files[index].fileName, url: data.signedUrl.split("?")[0] };
    });
  });
  
  return Promise.all(uploadPromises);
};

// Utility function to upload a single file
export const uploadFile = async (file, type) => {
  if (!file) {
    return null;
  }
  
  const signedUrl = await getSignedUrl(type, file.name);
  return uploadToS3(signedUrl, file);
};

// Utility function to upload multiple files
export const uploadFiles = async (files) => {
  const signedUrlsData = await getMultipleSignedUrls(files);
  return uploadMultipleToS3(signedUrlsData, files);
};